import ChartDataLabels from "chartjs-plugin-datalabels";
import { Line } from "react-chartjs-2";

import type { DataType } from "../../utils";
import type { LineChartData } from "../utils";
import { linePointsDataLabelsFormat, lineTooltipLabelFormat } from "./utils";
/**
 * Line chart and its config
 */
interface ILineChart {
    /**
     * Data for chart-js Line
     */
    data: LineChartData;
    /**
     * Data type for Y axis
     */
    dataType: DataType;
}

const LineChart = ({ data, dataType }: ILineChart) => {
    // Line Chart configuration
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                onClick: (e) => {}, // disable on clickable legend
                position: "top" as const,
                align: "end" as const,
                labels: {
                    usePointStyle: true,
                    pointStyle: "rectRounded",
                    pointStyleWidth: 18,
                    boxHeight: 5,
                    font: {
                        size: 10,
                    },
                },
            },
            datalabels: {
                anchor: "end",
                align: "top",
                offset: 3,
                display: "auto",
                formatter: (value: number, context) => linePointsDataLabelsFormat(value, context, data),
            },
            tooltip: {
                titleFont: { size: 10 },
                bodyFont: { size: 10 },
                displayColors: false,
                callbacks: {
                    label: (context) => lineTooltipLabelFormat(context, dataType),
                },
            },
        },
        scales: {
            x: {
                grid: {
                    display: false,
                },
            },
        },
    };

    return <Line data={data} options={options as any} plugins={[ChartDataLabels as any]} />;
};

export default LineChart;
